import {
    userEvents,
    CLICK_NEXT_SECTION,
    CLICK_GO_TO_NEXT_SECTION,
    CLICK_OPEN_RECORDER,
    CLICK_START_RECORDING,
    CLICK_STOP_RECORDING,
    CLICK_END_TEST,
    CLICK_RE_RECORD,
} from "../constants/testEvents";

function getLocaleDateTimeString(date) {
    return new Date(date).toLocaleString();
}

export function getTestSectionTimes(test) {
    // Optimization: sectionCreatedDate removed from backend
    if (!test?.sectionCreatedDate || !Array.isArray(test.sectionCreatedDate)) {
        return [];
    }
    return test.sectionCreatedDate.map((time, index) => ({
        label: `Section ${index + 2} start time`,
        value: getLocaleDateTimeString(time),
    }));
}

export function getTestEventStats(events) {
    if (!events || !events.length) return [];

    const filteredEvents = events.filter(({ eventType }) =>
        userEvents.some((event) => eventType?.includes(event))
    );

    let startRecordingKey = 1,
        reRecordingKey = 1;

    return filteredEvents.map(({ eventType, createdDate }) => {
        if (eventType.includes(CLICK_NEXT_SECTION)) {
            return {
                label: "Go to middle page click time",
                value: getLocaleDateTimeString(createdDate),
            };
        } else if (eventType.includes(CLICK_GO_TO_NEXT_SECTION)) {
            return {
                label: "Go to next section click time",
                value: getLocaleDateTimeString(createdDate),
            };
        } else if (eventType.includes(CLICK_OPEN_RECORDER)) {
            return {
                label: "Open recorder click time",
                value: getLocaleDateTimeString(createdDate),
            };
        } else if (eventType.includes(CLICK_START_RECORDING)) {
            const item = {
                label: `Start recording ${startRecordingKey} click time`,
                value: getLocaleDateTimeString(createdDate),
            };
            startRecordingKey += 1;
            return item;
        } else if (eventType.includes(CLICK_RE_RECORD)) {
            const item = {
                label: `Re-record ${reRecordingKey} click time`,
                value: getLocaleDateTimeString(createdDate),
            };
            reRecordingKey += 1;
            return item;
        } else if (eventType.includes(CLICK_STOP_RECORDING)) {
            return {
                label: "Stop recording click time",
                value: getLocaleDateTimeString(createdDate),
            };
        } else if (eventType.includes(CLICK_END_TEST)) {
            return {
                label: "Submit test click time",
                value: getLocaleDateTimeString(createdDate),
            };
        }
    });
}

export function getTestStats(test) {
    if (!test) return [];

    const stats = [];

    // Test start time - always available
    if (test.createdDate) {
        stats.push({
            label: "Test start time",
            value: getLocaleDateTimeString(test.createdDate),
        });
    }

    // Test end time - optimization: removed from backend
    if (test.endDate) {
        stats.push({
            label: "Test end time",
            value: getLocaleDateTimeString(test.endDate),
        });
    }

    // Section times - optimization: removed from backend
    stats.push(...getTestSectionTimes(test));

    // Drop-off details - optimization: removed from backend
    if (test?.droppedOffDetails) {
        stats.push({
            label: "Drop-off details",
            value: test?.droppedOffDetails?.status
                ? `true with ${test?.droppedOffDetails?.percentComplete}%`
                : "false",
        });
    }

    // User events - optimization: removed from backend
    stats.push(...getTestEventStats(test?.userEvents));

    return stats;
}

export function emailDeliveryStats(metrics) {
    if (!metrics) return [];

    // Check if metric has any actual data
    const hasTriggeredAt = metrics?.TriggeredAt;
    const hasDeliveredEvents = metrics?.deliveredEvents?.length > 0;
    const hasClickEvents = metrics?.clickEvents?.length > 0;
    const hasDeferredEvents = metrics?.deferredEvents?.length > 0;
    const hasBounceEvents = metrics?.bounceEvents?.length > 0;

    // If no data exists, return empty array so "No data" message shows instead
    if (!hasTriggeredAt && !hasDeliveredEvents && !hasClickEvents && !hasDeferredEvents && !hasBounceEvents) {
        return [];
    }

    return [
        ...(hasTriggeredAt
            ? [
                  {
                      label: "Triggered at",
                      value: getLocaleDateTimeString(metrics?.TriggeredAt),
                  },
              ]
            : []),
        ...(hasDeliveredEvents
            ? [
                  {
                      label: "Delivered",
                      value: getLocaleDateTimeString(
                          metrics?.deliveredEvents[0]?.modifiedTimeStamp
                      ),
                  },
              ]
            : []),
        ...(hasClickEvents
            ? [
                  {
                      label: "Clicked",
                      value: metrics?.clickEvents?.map((event) => {
                          return {
                              url: event?.url,
                              time: getLocaleDateTimeString(
                                  event?.modifiedTimeStamp
                              ),
                          };
                      }),
                  },
              ]
            : []),
        ...(hasDeferredEvents
            ? [
                  {
                      label: "Deferred",
                      value: metrics?.deferredEvents?.map((event) => {
                          return {
                              text: event?.response,
                              time: getLocaleDateTimeString(
                                  event?.modifiedTimeStamp
                              ),
                          };
                      }),
                  },
              ]
            : []),
        ...(hasBounceEvents
            ? [
                  {
                      label: "Bounced",
                      value: metrics?.bounceEvents?.map((event) => {
                          return {
                              text: event?.reason,
                              time: getLocaleDateTimeString(
                                  event?.modifiedTimeStamp
                              ),
                          };
                      }),
                  },
              ]
            : []),
    ];
}
